import { env } from 'env';

const { REACT_APP_CLIENT_ENV = 'Common' } = env;

export enum LanguageNamespaces {
  Common = 'common',
  EK = 'ek',
}

const NAMESPACE_MAP: { [key: string]: LanguageNamespaces } = {
  Common: LanguageNamespaces.Common,
  EK: LanguageNamespaces.EK,
};

export const LANGUAGE_NAMESPACE =
  NAMESPACE_MAP[REACT_APP_CLIENT_ENV] || LanguageNamespaces.Common;

export enum LanguageCodes {
  En = 'EN',
  Es = 'ES',
  Pt = 'PT',
  Fr = 'FR',
}

export const LANGUAGES = [
  {
    key: LanguageCodes.En,
    label: 'English',
  },
  {
    key: LanguageCodes.Es,
    label: 'Español',
  },
  {
    key: LanguageCodes.Pt,
    label: 'Português',
  },
  {
    key: LanguageCodes.Fr,
    label: 'Française',
  },
];
